module.exports = __webpack_public_path__ + "img/ctgshopping.87939e98.png";